var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"fade"}),_c('div',{staticClass:"Modal"},[_c('svg',{attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{attrs:{"r":"20","cy":"50","cx":"50"}})]),_c('h1',[_vm._v("Carregando")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }